import { render, staticRenderFns } from "./ExtraCharge.vue?vue&type=template&id=212b11d4&scoped=true&"
import script from "./ExtraCharge.vue?vue&type=script&lang=js&"
export * from "./ExtraCharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212b11d4",
  null
  
)

export default component.exports